import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Dropdown, { DropdownThreatHunter } from "../../../Components/common/Dropdown/Dropdown";

import { RequestDistinctLiveHosts } from "../../../store/actions/mailGatewayActions";
import { RequestDistinctLiveThreatHunters } from "../../../store/actions/integrationsActions";

const ProductsSidebar = ({ onItemSelect, selectedHost, selectedSub }) => {
  const mailGatewayHosts = useSelector((state) => state.mailGateway.distinctLiveHosts);
  const threatHunterHosts = useSelector((state) => state.integrations.distinctLiveThreatHunters);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(RequestDistinctLiveHosts());
    dispatch(RequestDistinctLiveThreatHunters());
  }, [dispatch]);

  useEffect(() => {
    if (mailGatewayHosts.length > 0 && !selectedHost) {
      onItemSelect("Mail Gateway", mailGatewayHosts[0]);
    } else if (threatHunterHosts.length > 0 && !selectedHost) {
      onItemSelect("Threat Hunter", threatHunterHosts[0], "Groups");
    }
  }, [mailGatewayHosts, threatHunterHosts, selectedHost, onItemSelect]);

  return (
    <div className="products-sidebar">
      <Dropdown
        title="Mail Gateway"
        selectedItem={selectedHost}
        items={mailGatewayHosts}
        onItemSelect={onItemSelect}
        fadeEmpty={true}
      />
      <DropdownThreatHunter
        title="Threat Hunter"
        selectedItem={selectedHost}
        selectedSub={selectedSub}
        items={threatHunterHosts}
        onItemSelect={onItemSelect}
        fadeEmpty={true}
      />
    </div>
  );
};

export default ProductsSidebar;
